@if (setpointTemplateCategory) {
  <section>
    <app-theme-page-container>
      <app-theme-page-section>
        <div class="form-group">
          <label for="title">Name of Category </label>
          <input id="title" name="title" maxlength="50" class="form-control" [(ngModel)]="setpointTemplateCategory.title" />
        </div>
        <div class="form-group">
          <div for="notes">Notes</div>
          <textarea [(ngModel)]="setpointTemplateCategory.notes" [style]="{ width: '100%', height: '200px' }"></textarea>
        </div>
        <div class="buttons">
          <div class="text-right">
            <app-button label="Cancel" icon="mdi mdi-close" (click)="cancel()"> </app-button>
            <app-button [label]="setpointTemplateCategory.id ? 'Update' : 'Create'" icon="mdi mdi-content-save" (click)="submit()"> </app-button>
          </div>
        </div>
      </app-theme-page-section>
    </app-theme-page-container>
  </section>
}
